import { l } from 'client/Other/Translation'

import { actionCreator } from './'
import { navigateAddModal, navigateRemoveModal } from './navigation'

export const ongoingAdd = actionCreator<string>('ONGOING_ADD')
export const ongoingRemove = actionCreator<string>('ONGOING_REMOVE')

export const showGeneratingDocumentSpinner = () => {
  return (dispatch, getState) =>
    dispatch(
      navigateAddModal({
        component: 'LoadingModal',
        props: {
          header: l('pdfSpinnerHeader'),
          boldText: l('pdfSpinnerBold'),
          text: l('pdfSpinnerText'),
        },
      }),
    )
}

export const hideGeneratingDocumentSpinner = () => {
  return (dispatch, getState) => dispatch(navigateRemoveModal('LoadingModal'))
}
